import React from 'react';
import HeaderThree from "../common/header/HeaderThree";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import SingleGeneralContracting5 from '../components/single-service/SingleGeneralContracting5';
import BrandOne from '../components/brand/BrandOne';
import FooterOne from '../common/footer/FooterOne';

const GeneralContracting5 = () => {
    return (
        <>
            <HeaderThree />
            <Breadcrumb
                heading="Acesso por Corda"
                currentPage="serviço" 
                Img="IMG-20230809-WA0072.jpg"
            />
            <SingleGeneralContracting5 />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default GeneralContracting5;